var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterogation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#243D63",
    d: "M5.414 6.482a.27.27 0 0 1-.21-.084.38.38 0 0 1-.07-.238c0-.145.017-.28.05-.406a1.62 1.62 0 0 1 .174-.392c.08-.13.185-.268.315-.413.098-.112.175-.21.231-.294a.907.907 0 0 0 .168-.497.44.44 0 0 0-.168-.364c-.112-.089-.27-.133-.476-.133a1.61 1.61 0 0 0-.51.077c-.15.047-.302.114-.456.203a.505.505 0 0 1-.28.084.321.321 0 0 1-.196-.091.353.353 0 0 1-.098-.189.372.372 0 0 1 .035-.231.553.553 0 0 1 .203-.217c.192-.126.411-.222.658-.287a2.58 2.58 0 0 1 .7-.105c.294 0 .551.049.77.147a1.2 1.2 0 0 1 .518.406c.126.173.19.376.19.609 0 .145-.022.282-.064.413a1.48 1.48 0 0 1-.203.385 2.996 2.996 0 0 1-.385.413 3.5 3.5 0 0 0-.35.357 1.4 1.4 0 0 0-.189.308 1.353 1.353 0 0 0-.077.315.22.22 0 0 1-.084.161.283.283 0 0 1-.196.063ZM5.4 7.945a.52.52 0 0 1-.385-.147.526.526 0 0 1-.14-.378c0-.15.047-.27.14-.364a.52.52 0 0 1 .385-.147.492.492 0 0 1 .518.511c0 .154-.046.28-.14.378-.088.098-.214.147-.378.147Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.46,
    cy: 5.46,
    r: 4.96,
    stroke: "#243D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterogation);
export default __webpack_public_path__ + "static/media/interogation.170f322f9a8f4f3be3dfb377eea6f54b.svg";
export { ForwardRef as ReactComponent };